import checkRenewal from '../services/check-renewal';

export default async (to, from, next) => {
  try {
    const response = await checkRenewal(to.params.hash);
    const { data } = response.data;

    sessionStorage.setItem('register', JSON.stringify(data.customer));
    sessionStorage.setItem('preRegistered', true);
    sessionStorage.setItem('campaign', data.name);
    sessionStorage.setItem('bank_slip', data.bank_slip);
    sessionStorage.setItem('credit_card', data.credit_card);
    sessionStorage.setItem('credit_card_installments', data.credit_card_installments);
    sessionStorage.setItem('subscription', data.subscription);
    sessionStorage.setItem('physical_card', data.physical_card);
    sessionStorage.setItem('physical_card_message', data.physical_card_message);
    sessionStorage.setItem('renewal', '1');
    sessionStorage.setItem('clientId', data.id);
    sessionStorage.setItem('env', data.environment);

    next({
      name: 'selecionar-pagamento',
      params: {
        programId: data.program_id
      }
    });
  } catch (error) {
    sessionStorage.setItem('error_reason', error.message);
    next({ name: 'subscription-error' });
  }
};
